import { jsonProperty, Serializable } from "ts-serializable";

class BaseResponse<T> extends Serializable{

    @jsonProperty(Boolean, null)
    success: boolean = true;

    @jsonProperty([String], null)
    errors: string[] | null = [];

    @jsonProperty(Object, null)
    data: T | null = null;

}

export default BaseResponse;